export default function FinalClassification({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Final Classification")}</legend>
      <input
        type="number"
        onChange={onChange}
        value={searchObject.finalClassification || ""}
        name="finalClassification"
        className="form-control fontsize-legend"
        min="0"
        onInput={(e) => {
          e.target.value = e.target.value.slice(0, 10);
        }}
      />
    </div>
  );
}
